import styled from 'styled-components';
import { HistoryCard, HistoryContainer, HistoryList } from '../History/History.styled';

export const WithdrawalHistoryContainer = styled(HistoryContainer)``

export const WithdrawalHistoryCard = styled(HistoryCard)``

export const WithdrawalHistoryList = styled(HistoryList)`
    display: flex;
    flex-direction: row;
`